/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Pasted_DocumentInputs */



/**
* | output |
* | --- |
* | "Pasted Document" |
*
* @param {Chat_Pasted_DocumentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_pasted_document = /** @type {((inputs?: Chat_Pasted_DocumentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Pasted_DocumentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eingefügtes Dokument")
	return /** @type {LocalizedString} */ ("Pasted Document")
});